import { render, staticRenderFns } from "./DashCartridgeUsage.vue?vue&type=template&id=44c2838e&scoped=true"
import script from "./DashCartridgeUsage.vue?vue&type=script&lang=js"
export * from "./DashCartridgeUsage.vue?vue&type=script&lang=js"
import style0 from "./DashCartridgeUsage.vue?vue&type=style&index=0&id=44c2838e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c2838e",
  null
  
)

export default component.exports